import { Component } from 'react';

import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import JLoading from 'components/JLoading';
import * as E from './styles';

class MessengerListDispatcherCompose extends Component {
  componentDidMount() {
    const { messengerStore } = this.props.store;
    messengerStore.getDispatchers();
  }

  handleClickUser() {
    // console.log(userId);
  }

  render() {
    const { messengerStore } = this.props.store;
    const { upserting, followers, topicSelected, dispatchers } = messengerStore;

    return (
      <E.Container>
        <E.Title>{`Dispatcher list`}</E.Title>
        <E.Inner>
          {dispatchers.length && topicSelected ? (
            <E.Scrollable>
              {messengerStore.dispatchers.map((dispatcher, index) => (
                <ActiveMember followers={topicSelected?.follower_ids || []} dispatcher={dispatcher} key={`dispatcher-${index}`} />
              ))}
            </E.Scrollable>
          ) : (
            <JLoading />
          )}
        </E.Inner>
      </E.Container>
    );
  }
}
export const MessengerListDispatcher = compose(withRouter, inject('store'), observer)(MessengerListDispatcherCompose);

class ActiveMemberCompose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      followers: this.props.followers,
    };
  }

  _handleClickUser = (e, userId) => {
    const { messengerStore } = this.props.store;
    const { followers, unFollowers, forceFollow, forceUnfollow } = messengerStore;
    let _followers = this.state.followers;
    if (e.target.checked) {
      _followers.push(userId);
      messengerStore.forceFollow([userId]);
    } else {
      _followers = _followers.map((f) => f !== userId && f).filter((f) => f);
      messengerStore.forceUnfollow([userId]);
    }

    this.setState({ followers: _followers });
  };

  render() {
    const { dispatcher } = this.props;

    return (
      <E.ActiveMember>
        <E.Column>
          <E.Avatar>
            <E.AvatarImage />
          </E.Avatar>
          <E.Name>
            <E.UserName>
              {this.props.dispatcher.username} - <E.CodeId>{this.props.dispatcher.id}</E.CodeId>
            </E.UserName>
          </E.Name>
        </E.Column>
        {dispatcher && (
          <E.CheckBox
            checked={this.state.followers.indexOf(dispatcher.id) !== -1}
            type={'checkbox'}
            onChange={(e) => this._handleClickUser(e, dispatcher.id)}
          />
        )}
      </E.ActiveMember>
    );
  }
}
export const ActiveMember = compose(withRouter, inject('store'), observer)(ActiveMemberCompose);

export default {
  MessengerListDispatcher,
};
